export default {
  tagline: "Un jeu d'ambiance et de mots en ligne. 🕵️‍♂️",
  "create-game": "Créer une partie",
  "new-game": "Nouvelle partie",
  "back-to-lobby": "Revenir au lobby",
  "join-room": "Rejoindre une partie",
  "no-public-room":
    "Il n'y a pas de partie publique. Créez-en une et invitez vos amis !",
  "how-to-play": "Comment jouer",
  "game-tagline":
    "Codegame est un jeu de déduction où deux équipes s'affrontent pour trouver des mots en rapport avec l'indice donné par leur équipier.",
  "see-more": "Voir plus...",
  "classic-rules": "Règles classiques",
  "duet-rules": "Règles Duet",
  "support-authors":
    "Les mécaniques de ce jeu sont inspirées de Codenames, mais n'est pas affilié à CGE, l'éditeur de Codenames. Si vous aimez ce jeu, soutenez ses auteurs en achetant une version physique.",
  "made-with-love": "Fabriqué avec ♥ en confinement",
  "its-open-source": "C'est <1>open-source</1>.",
  "check-our-privacy-policy":
    "Consultez notre <2>politique de confidentialité</2>.",
  "choose-options": "Choisissez vos options",
  mode: "Mode",
  duet: "Duet",
  classic: "Classique",
  dictionary: "Dictionnaire",
  "public-game": "Partie publique",
  private: "Privé",
  public: "Public",
  "join-game": "Rejoindre la partie",
  "placeholder-join": "rejoignez la partie pour discuter",
  "give-hint": "donner l'indice",
  "clicked-on": "a cliqué sur",
  "become-spymaster": "Devenir Maître-Espion",
  "switch-teams": "Changer d'équipe",
  "red-adj": "rouge",
  "blue-adj": "bleu",
  "start-game-classic":
    "Le Maître-Espion <1>{{team}}</1> commence à donner un indice !",
  "see-rules": "Voir les règles",
  "start-game-duet":
    "Pour commencer, l'un d'entre vous doit donner un indice !",
  "copied-to-clipboard": "Lien copié!",
  "turns-left": "{{ count }} tour restant",
  "turns-left_plural": "{{ count }} tours restants",
  "game-over": "Le jeu est terminé.",
  "winner-team": "L'équipe <1>{{team}}</1> a gagné !",
  "black-card-loss": "Vous avez perdu car vous avez cliqué sur un assassin.",
  "out-of-time-loss": "Vous n'avez plus de temps !",
  won: "Vous avez gagné !",
  "join-red": "équipe rouge",
  "join-blue": "équipe bleue",
  "join-side": "Côté",
  spectate: "Spectateur",
  "game-started": "commencé",
  "page-title": "Codegame - Jouez en ligne",
  "page-description":
    "Jouez à Codegame en ligne, un jeu de mots multijoueur disponible sur mobile et ordinateur. Dans ce jeu de déduction, les équipes s'affrontent pour trouver les cartes en rapport avec un indice.",
  "in-the-room": "Dans la partie",
  rules: "Règles",
  // todo rules...
  red: "Rouge",
  blue: "Bleu",
  duetA: "Côté A",
  duetB: "Côté B",
  spectator: "Spectateurs",
  "just-joined": "a rejoint la partie !",
  "game-created": "La partie a été créée.",
  "no-players-yet": "Il n'y a pas encore de joueurs dans cette équipe.",
  cards: "cartes",
  buymeacoffee: "Soutenez Codegame en m'offrant un café",
  "player-name-placeholder": "Nom de joueur",
  "positive-reaction-1": "Joli !",
  "positive-reaction-2": "Bien joué !",
  "positive-reaction-3": "Très bien cliqué.",
  "positive-reaction-4": `Un point de plus !`,
  "positive-reaction-5": "Youpi !",
  "positive-reaction-6": "😎",
  "neutral-reaction-1": "Un coup dans l'eau.",
  "neutral-reaction-2": "C'était presque ça.",
  "neutral-reaction-3": "Tant pis, la prochaine fois.",
  "neutral-reaction-4": "C'était un civil.",
  "neutral-reaction-5": `Presque !`,
  "neutral-reaction-6": "Dommage.",
  "black-reaction-1": "Vous avez perdu la partie !",
  "black-reaction-2": "L'autre équipe a gagné!",
  "black-reaction-3": "Votre équipe vient de perdre ☠️",
  "black-reaction-4": "Oh non, vous avez cliqué sur un assassin ☠️",
  "negative-reaction-1": "Oups !",
  "negative-reaction-2": "Oh non !",
  "negative-reaction-3": `L'autre équipe vous remercie.`,
  "negative-reaction-4": "C'est pas si grave 💛.",
  "negative-reaction-5": "🤦‍♂️",
  "rules-classic-teams": `Les joueurs sont répartis en deux équipes: <1>rouge</1> and <3>bleu</3>. Un joueur de chaque équipe est désigné Maître-Espion 🕵️‍♂️ - les autres sont des agents de terrain.`,
  "rules-classic-grid": `Vingt-cinq mots sont disposés au hasard en grille. Certains de ces mots représentent des agents <1>rouges</1>, d'autre des agents <3>bleus</3>, un mot représente un <5>assassin</5>, et les autres sont des <7>civils innocents</7>. Les Maître-Espions de chaque équipe connaissent les couleurs des mots, et jouent tour à tour pour faire deviner les mots de leur couleur à leur équipe.`,
  "rules-classic-hints": `Chaque indice ne peut consister que d'un mot, et du nombre de carte auquel il fait référence. Les Maîtres-Espion donnent des indices qui se rapportent au plus possible de mots de leur couleur, mais à aucun des autres - ils pourraient accidentellement mener leur équipe à choisir une carte qui représente un civil innocent, un agent de l'équipe adverse, ou l'assassin.`,
  "rules-hint-restrictions": `Le mot de l'indice peut être choisi librement, tant qu'il ne s'agit pas d'un mot de la même famille qu'un autre mot encore visible sur la grille. Les indices phonétiques sont normalement interdits.`,
  "rules-turns":
    "Les cartes sont révélées au fur et à mesure que les équipiers les devinent. Les agents de terrain doivent cliquer au moins une fois sur un mot par tour, risquant ainsi de faire un mauvais choix et de devoir laisser la main à l'autre équipe. Ils peuvent ensuite passer leur tour à n'importe quel moment. Ils peuvent deviner un nombre de mot égal au nombre donné par le Maître-Espion, plus un mot bonus pour deviner un mot se rapportant à un indice précédent.",
  "rules-classic-game-end": `Le jeu se termine lorsque tous les agents d'une équipe ont été identifiés (🏅), ou lorsqu'une des équipe clique sur l'<1>assassin</1> (☠️).`,
  "rules-duet-objective": `Deux joueurs coopèrent pour trouver 15 mots sur le plateau.`,
  "rules-duet-grid": `Vingt-cinq mots sont disposés au hasard en grille. Certains de ces mots représentent des agents <1>verts</1>, certains mots des <3>assassins</3>, les autres des <5>civils innocents</5>. Chaque joueur connaît 9 mots <7>verts</7>, certains étant en commun avec l'autre joueur.`,
  "rules-duet-hints": `Les joueurs donnent alternativement des indices pour faire deviner ses mots verts à son partenaire. Chaque indice ne peut consister que d'un mot, et du nombre de carte auquel il fait référence. Le joueur dont c'est le tour donne un indice qui se rapporte au plus possible de mots verts, mais à aucun des autres – il pourrait accidentellement mener son partenaire à choisir une carte qui représente un civil innocent ou un assassin.`,
  "rules-duet-game-end": `Le jeu se termine lorsque les 15 agents verts ont été identifiés (🏅), ou lorsqu'un des joueurs clique sur un <1>assassin</1> (☠️). Le jeu est chronométré : les joueurs disposent d'un total de 9 tours pour trouver tous les mots. Cliquer sur un <3>civil innocent</span> consomme un tour supplémentaire.`,
  "long-story-short": "En résumé",
  "privacy-tldr": `
  <p>Nous gardons les parties et les messages du chat dans une base de données temporaires, mais ils peuvent être supprimés à n'importe quel moment. C'est la seule information que nous stockons.</p>
  <p>Nous utilisons des cookies pour savoir comment le site est utilisé (audience, longueur des sessions, types de parties jouées). Ces statistiques ne comportent pas de données personnellement identifiables.</p>
  <p>Pour cela, nous utilisons Google Analytics.</p>
`,
};
